import React, { useState } from "react";
import { Card, Nav } from "react-bootstrap";
import Misterio from "../components/Misterio";

const getMisterioDelDia = () => {
  const misteriosPorDia = {
    0: "3", // Domingo -> Gloriosos
    1: "1", // Lunes -> Gozosos
    2: "2", // Martes -> Dolorosos
    3: "3", // Miércoles -> Gloriosos
    4: "4", // Jueves -> Luminosos
    5: "2", // Viernes -> Dolorosos
    6: "1", // Sábado -> Gozosos
  };

  return misteriosPorDia[new Date().getDay()];
};

export default function SantoRosario() {
  const [subNav, setSubNav] = useState(getMisterioDelDia);

  const handleSelect = (eventKey) => {
    setSubNav(eventKey);
  };

  return (
    <>
      <Card className="pt-5 rosario">
        <Card.Header>
          <Nav variant="tabs" activeKey={subNav} onSelect={handleSelect}>
            <Nav.Item>
              <Nav.Link eventKey="1">Gozosos <br /> <span>Lun - Sab</span></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="2">Dolorosos <br /> <span>Mar - Vie</span></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="3">Gloriosos <br /> <span>Mie - Dom</span></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="4">Luminosos <br /> <span>Jue</span></Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        {subNav === "1" && <Misterio misterio="gozoso" />}
        {subNav === "2" && <Misterio misterio="doloroso" />}
        {subNav === "3" && <Misterio misterio="glorioso" />}
        {subNav === "4" && <Misterio misterio="luminoso" />}
      </Card>
    </>
  );
}
